import * as React from 'react'
import { FieldError, UseFormRegister } from 'react-hook-form'
import { Col } from './flex'

export interface InputProps extends React.HTMLAttributes<HTMLInputElement> {
    name: string
    label?: string
    error?: FieldError
    className?: string
    inputClassName?: string
    register: UseFormRegister<any>
    required?: boolean | string
    type?: string
}

export const Input = ({
    name,
    label,
    error,
    type = 'text',
    className = '',
    inputClassName = '',
    register,
    required,
    ...rest
}: InputProps) => (
    <Col className={className}>
        {label && (
            <label className="text-base text-gray-700 pb-1">{`${label}`}</label>
        )}
        <input
            {...rest}
            type={type}
            className={`outline-none text-base p-3 bg-gray-100 placeholder-gray-500 ${inputClassName}`}
            {...register(name, { required })}
        />
        <p className="h-4 mt-1 text-xs text-red-500">{error?.message}</p>
    </Col>
)
